/**
 * Appends `?subawardee=` (or `&subawardee=`) when a subawardee is selected so admin routes stay in sync.
 */
export function withAdminSubawardeeQuery(path: string, subawardee: string | null): string {
  if (!subawardee) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}subawardee=${encodeURIComponent(subawardee)}`;
}

  // List routes that show the shared "Filter by Subawardee" control (reports only; milestones uses its own URL state).
export function isAdminSubawardeeFilterListRoute(pathname: string): boolean {
  const p = pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;
  return p === '/admin/reports';
}

export function isAdminMilestonesRoute(pathname: string): boolean {
  const p = pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;
  return p === '/admin/milestones';
}

export function buildAdminMilestonesPath(options: {
  view: 'component' | 'subawardee';
  subawardee?: string | null;
}): string {
  const params = new URLSearchParams();
  params.set('view', options.view);
  if (options.view === 'subawardee' && options.subawardee) {
    params.set('subawardee', options.subawardee);
  }
  const qs = params.toString();
  return qs ? `/admin/milestones?${qs}` : '/admin/milestones';
}
